import * as React from "react";
import {Fragment} from "react";

import {useAppDispatch, useAppSelector} from "../../redux/storeHooks";
import {setMemberFormValue} from "./memberFormSlice";

const MemberFormInputs = () => {

  const dispatch = useAppDispatch();
  const {instagramPage, marketingGoals} = useAppSelector((store) => store.memberFormState);

  const handleChangeInput = (event: React.FormEvent<HTMLInputElement>) => {
    dispatch(setMemberFormValue({
      name: event.currentTarget.name,
      value: event.currentTarget.value
    }));
  }
  const handleChangeTextArea = (event: React.FormEvent<HTMLTextAreaElement>) => {
    dispatch(setMemberFormValue({
      name: event.currentTarget.name,
      value: event.currentTarget.value
    }));
  }

  return (
    <Fragment>
      <div className="ui-form__block flex flex--column ">
        <label className="ui-label text-left" htmlFor="instagramPage">Enter your Instagram page</label>
        <input className="ui-input width-100"
               onChange={handleChangeInput}
               value={instagramPage}
               type="text"
               name="instagramPage"
               id="instagramPage"
               placeholder="@pagename_example"/>
      </div>
      <div className="ui-form__block">
        <label className="ui-label" htmlFor="marketingGoals">Provide your marketing goals</label>
        <textarea className="ui-textarea width-100"
                  onChange={handleChangeTextArea}
                  value={marketingGoals}
                  name="marketingGoals"
                  id="marketingGoals"
                  placeholder="Please, tell us how would you like to promote your account?"></textarea>
      </div>
    </Fragment>
  )
}

export default MemberFormInputs
